import Vue from 'vue'
import Vuex from 'vuex'

import one from './modules/one'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    one
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js